// export action types
import { ADD_COMPONENT_DATA } from 'constants/redux-events';

/********************************************************/

/**
 * @type {function}
 * @param {object} payload - payload object (data to dispatch)
 * @desc Returns action object for **TYPE_SOME_EVENT** event
 * @returns {object} - Redux action object
 * @property {string} type - Event name (from constant)
 * @property {object} payload - payload to dispatch
 * @example
 * import { addComponentData } from 'actions/addComponentData';
 *
 * // dispatch action
 * store.dispatch( addComponentData( payload ) );
 */
export const addComponentData = ( payload ) => {
    return {
        type: ADD_COMPONENT_DATA,
        payload: payload
    };
};
